/**
 * Comprehensive Phrases Data - Grade 5-6 Advanced
 * 小学5-6年级进阶短语
 *
 * 包含比较级、时态、句型等进阶表达，约40个短语
 */

import { Phrase } from './phrases-types';

export const grade5to6AdvancedPhrases: Phrase[] = [
  // ==================== 比较级和最高级 Comparative & Superlative ====================

  // 比较级短语
  {
    id: 'comp_better_than',
    phrase: 'better than',
    phonetic: '/ˈbetər ðæn/',
    meaning: '比……更好',
    usageScenario: '比较两个事物，表示一个比另一个更好',
    example: 'This book is better than that one.',
    exampleTranslation: '这本书比那本更好。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'comp_worse_than',
    phrase: 'worse than',
    phonetic: '/wɜːrs ðæn/',
    meaning: '比……更差',
    usageScenario: '比较两个事物，表示一个比另一个更差',
    example: 'This weather is worse than yesterday.',
    exampleTranslation: '今天的天气比昨天更差。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'comp_bigger_than',
    phrase: 'bigger than',
    phonetic: '/ˈbɪɡər ðæn/',
    meaning: '比……更大',
    usageScenario: '比较大小，表示一个比另一个更大',
    example: 'My house is bigger than yours.',
    exampleTranslation: '我的房子比你的更大。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'comp_smaller_than',
    phrase: 'smaller than',
    phonetic: '/ˈsmɔːlər ðæn/',
    meaning: '比……更小',
    usageScenario: '比较大小，表示一个比另一个更小',
    example: 'This box is smaller than that one.',
    exampleTranslation: '这个盒子比那个更小。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'comp_taller_than',
    phrase: 'taller than',
    phonetic: '/ˈtɔːlər ðæn/',
    meaning: '比……更高',
    usageScenario: '比较身高，表示一个比另一个更高',
    example: 'My brother is taller than me.',
    exampleTranslation: '我哥哥比我更高。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'comp_shorter_than',
    phrase: 'shorter than',
    phonetic: '/ˈʃɔːrtər ðæn/',
    meaning: '比……更矮',
    usageScenario: '比较身高，表示一个比另一个更矮',
    example: 'She is shorter than her sister.',
    exampleTranslation: '她比她姐姐更矮。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'comp_faster_than',
    phrase: 'faster than',
    phonetic: '/ˈfæstər ðæn/',
    meaning: '比……更快',
    usageScenario: '比较速度，表示一个比另一个更快',
    example: 'Cheetah is faster than lion.',
    exampleTranslation: '猎豹比狮子更快。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'comp_slower_than',
    phrase: 'slower than',
    phonetic: '/ˈsloʊər ðæn/',
    meaning: '比……更慢',
    usageScenario: '比较速度，表示一个比另一个更慢',
    example: 'Turtle is slower than rabbit.',
    exampleTranslation: '乌龟比兔子更慢。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'comp_more_beautiful',
    phrase: 'more beautiful than',
    phonetic: '/mɔːr ˈbjuːtɪfl ðæn/',
    meaning: '比……更漂亮',
    usageScenario: '比较外观，表示一个比另一个更漂亮',
    example: 'This flower is more beautiful than that one.',
    exampleTranslation: '这朵花比那朵更漂亮。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'comp_more_interesting',
    phrase: 'more interesting than',
    phonetic: '/mɔːr ˈɪntrəstɪŋ ðæn/',
    meaning: '比……更有趣',
    usageScenario: '比较趣味性，表示一个比另一个更有趣',
    example: 'This game is more interesting than that one.',
    exampleTranslation: '这个游戏比那个更有趣。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'medium'
  },

  // 最高级短语
  {
    id: 'super_the_best',
    phrase: 'the best',
    phonetic: '/ðə best/',
    meaning: '最好的',
    usageScenario: '在三个或以上的事物中表示最好的',
    example: 'This is the best book I have ever read.',
    exampleTranslation: '这是我读过的最好的书。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'super_the_worst',
    phrase: 'the worst',
    phonetic: '/ðə wɜːrst/',
    meaning: '最差的',
    usageScenario: '在三个或以上的事物中表示最差的',
    example: 'This is the worst weather this year.',
    exampleTranslation: '这是今年最差的天气。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'super_the_biggest',
    phrase: 'the biggest',
    phonetic: '/ðə ˈbɪɡɪst/',
    meaning: '最大的',
    usageScenario: '在三个或以上的事物中表示最大的',
    example: 'This is the biggest apple in the basket.',
    exampleTranslation: '这是篮子里最大的苹果。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'super_the_smallest',
    phrase: 'the smallest',
    phonetic: '/ðə ˈsmɔːlɪst/',
    meaning: '最小的',
    usageScenario: '在三个或以上的事物中最小的',
    example: 'This is the smallest bird in the world.',
    exampleTranslation: '这是世界上最小的鸟。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'super_the_tallest',
    phrase: 'the tallest',
    phonetic: '/ðə ˈtɔːlɪst/',
    meaning: '最高的',
    usageScenario: '在三个或以上的人或物中最高的',
    example: 'He is the tallest student in our class.',
    exampleTranslation: '他是我们班最高的学生。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'super_the_fastest',
    phrase: 'the fastest',
    phonetic: '/ðə ˈfæstɪst/',
    meaning: '最快的',
    usageScenario: '在三个或以上的事物中最快的',
    example: 'Cheetah is the fastest animal on land.',
    exampleTranslation: '猎豹是陆地上最快的动物。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },

  // ==================== 时态相关 Tense Related ====================

  // 现在进行时
  {
    id: 'tense_be_doing',
    phrase: 'be doing',
    phonetic: '/biː ˈduːɪŋ/',
    meaning: '正在做……',
    usageScenario: '描述正在进行的动作，现在进行时',
    example: 'I am reading a book now.',
    exampleTranslation: '我正在看书。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'tense_is_doing',
    phrase: 'is doing',
    phonetic: '/ɪz ˈduːɪŋ/',
    meaning: '（他/她/它）正在做……',
    usageScenario: '描述第三人称正在进行的动作',
    example: 'He is playing football.',
    exampleTranslation: '他正在踢足球。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'tense_are_doing',
    phrase: 'are doing',
    phonetic: '/ɑːr ˈduːɪŋ/',
    meaning: '（我们/你们/他们）正在做……',
    usageScenario: '描述复数人称正在进行的动作',
    example: 'They are having lunch.',
    exampleTranslation: '他们正在吃午餐。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },

  // 一般过去时
  {
    id: 'tense_did',
    phrase: 'did...',
    phonetic: '/dɪd/',
    meaning: '做了……（过去时）',
    usageScenario: '描述过去发生的动作',
    example: 'I did my homework yesterday.',
    exampleTranslation: '我昨天做了作业。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'tense_was',
    phrase: 'was...',
    phonetic: '/wɒz/',
    meaning: '是……（过去时，单数）',
    usageScenario: '描述过去的状态（I/he/she/it）',
    example: 'I was happy yesterday.',
    exampleTranslation: '我昨天很开心。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'tense_were',
    phrase: 'were...',
    phonetic: '/wɜːr/',
    meaning: '是……（过去时，复数）',
    usageScenario: '描述过去的状态（we/you/they）',
    example: 'They were late yesterday.',
    exampleTranslation: '他们昨天迟到了。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },

  // 一般将来时
  {
    id: 'tense_will_do',
    phrase: 'will do',
    phonetic: '/wɪl duː/',
    meaning: '将要做……',
    usageScenario: '描述将来要发生的动作',
    example: 'I will visit Beijing next week.',
    exampleTranslation: '我下周要参观北京。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'tense_be_going_to',
    phrase: 'be going to',
    phonetic: '/biː ˈɡoʊɪŋ tuː/',
    meaning: '打算做……',
    usageScenario: '描述计划或打算将来要做的事',
    example: "I'm going to learn English.",
    exampleTranslation: '我打算学英语。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'tense_will_be',
    phrase: 'will be',
    phonetic: '/wɪl biː/',
    meaning: '将会是……',
    usageScenario: '描述将来会存在的状态',
    example: 'It will be sunny tomorrow.',
    exampleTranslation: '明天将会是晴天。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },

  // ==================== 感叹句 Exclamations ====================

  {
    id: 'excl_how_beautiful',
    phrase: 'How beautiful!',
    phonetic: '/haʊ ˈbjuːtɪfl/',
    meaning: '多美啊！',
    usageScenario: '表达强烈的赞美和感叹',
    example: 'How beautiful the flower is!',
    exampleTranslation: '这朵花多美啊！',
    category: 'feelings',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'excl_what_a_day',
    phrase: 'What a nice day!',
    phonetic: '/wɒt ə naɪs deɪ/',
    meaning: '多么美好的一天！',
    usageScenario: '感叹天气好或日子美好',
    example: 'What a nice day! Let\'s go out!',
    exampleTranslation: '多么美好的一天！我们出去吧！',
    category: 'feelings',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'excl_how_clever',
    phrase: 'How clever!',
    phonetic: '/haʊ ˈklevər/',
    meaning: '多聪明啊！',
    usageScenario: '称赞某人聪明',
    example: 'How clever you are!',
    exampleTranslation: '你多聪明啊！',
    category: 'feelings',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },

  // ==================== 连接词 Conjunctions ====================

  {
    id: 'conj_and_then',
    phrase: 'and then',
    phonetic: '/ænd ðen/',
    meaning: '然后',
    usageScenario: '连接两个连续发生的动作',
    example: 'I had breakfast and then went to school.',
    exampleTranslation: '我吃了早餐然后去学校。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'conj_but',
    phrase: 'but...',
    phonetic: '/bʌt/',
    meaning: '但是……',
    usageScenario: '表示转折关系',
    example: 'I like apples but I don\'t like bananas.',
    exampleTranslation: '我喜欢苹果但是我不喜欢香蕉。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'conj_or',
    phrase: 'or...',
    phonetic: '/ɔːr/',
    meaning: '或者……',
    usageScenario: '表示选择关系',
    example: 'Do you want tea or coffee?',
    exampleTranslation: '你想要茶还是咖啡？',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'conj_because',
    phrase: 'because...',
    phonetic: '/bɪˈkɒz/',
    meaning: '因为……',
    usageScenario: '说明原因',
    example: 'I am happy because today is my birthday.',
    exampleTranslation: '我很开心因为今天是我的生日。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'conj_so',
    phrase: 'so...',
    phonetic: '/soʊ/',
    meaning: '所以……',
    usageScenario: '表示结果',
    example: "It's late, so I must go home.",
    exampleTranslation: '很晚了，所以我必须回家。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'conj_if',
    phrase: 'if...',
    phonetic: '/ɪf/',
    meaning: '如果……',
    usageScenario: '表示条件',
    example: 'If it rains, I will stay home.',
    exampleTranslation: '如果下雨，我就待在家里。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'conj_when',
    phrase: 'when...',
    phonetic: '/wen/',
    meaning: '当……时候',
    usageScenario: '表示时间关系',
    example: 'When I grow up, I want to be a teacher.',
    exampleTranslation: '当我长大后，我想当一名老师。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'high'
  },
];